import { TagType } from '../types/interfaces';

export const taskStatusCardOptions: TagType[] = [
  { label: 'Шифр 1', id: 17038739565341 },
  { label: 'Шифр 2', id: 17038739565331 },
  { label: 'Шифр 3', id: 17038739565321 },
  { label: 'Шифр 4', id: 17038739565311 },
  { label: 'Шифр 5', id: 17038739565301 },
  { label: 'Шифр 6', id: 17038739565322 },
  { label: 'Шифр 7', id: 17038739565332 },
  { label: 'Шифр 8', id: 17038739565358 },
  { label: 'Шифр 9', id: 17038739565359 },
  { label: 'Шифр 10', id: 170387395653510 },
  { label: 'Шифр 11', id: 170387395653511 },
  { label: 'Шифр 12', id: 170387395653512 },
  { label: 'Шифр 13', id: 170387395653513 },
  { label: 'Шифр 14', id: 170387395653514 },
  { label: 'Шифр 15', id: 170387395653515 },
  { label: 'Шифр 16', id: 170387395653516 },
  { label: 'Шифр 17', id: 170387395653517 },
  { label: 'Шифр 18', id: 170387395653518 },
  { label: 'Шифр 19', id: 170387395653519 },
  { label: 'Шифр 20', id: 170387395653520 },
  { label: 'Шифр 21', id: 170387395653521 },
  { label: 'Шифр 22', id: 170387395653522 },
  { label: 'Шифр 23', id: 170387395653523 },
  { label: 'Шифр 24', id: 170387395653524 },
  { label: 'Шифр 25', id: 170387395653525 },
  { label: 'Шифр 26', id: 170387395653526 },
  { label: 'Шифр 27', id: 170387395653527 },
  { label: 'Шифр 28', id: 170387395653528 },
  { label: 'Шифр 29', id: 170387395653529 },
  { label: 'Шифр 30', id: 17038739565371 }
];
